// this linting rule was flagging errors even after they had been addressed in various manners
/* eslint-disable jsx-a11y/label-has-for */
import React, { Component } from 'react';
import './DetectionResults.css';
import ReactTable from 'react-table';
import moment from 'moment';
import { t } from 'i18next';
import { FaQuestionCircleO as Help } from 'react-icons/lib/fa';
import DetectionSplash from '../../subComponents/splashscreen/detectionResSplash';
import Modal from '../../subComponents/modals/Modal';

import MovingAverageGraph from '../../subComponents/TensorGraphs/MovingAverageGraph/MovingAverageGraph';
import DeepARGraph from '../../subComponents/DeepARGraph/DeepARGraph';
import RCFGraphs from '../../subComponents/TensorGraphs/RCFGraphs/RCFGraphs';
import KMeansGraphs from '../../subComponents/TensorGraphs/KMeansGraphs/KMeansGraphs';

import MovingAverageGraphMultivariate
  from '../../subComponents/TensorGraphs/MovingAverageGraph/MovingAverageGraphMultivariate';
import RCFGraphsMultivariate from '../../subComponents/TensorGraphs/RCFGraphs/RCFGraphsMultivariate';
import KMeansGraphsMultivariate from '../../subComponents/TensorGraphs/KMeansGraphs/KMeansGraphsMultivariate';

import Navbar from '../../subComponents/navBar/navBar';
import FailurePredictionGraphComponent from
  '../../subComponents/TensorGraphs/FailurePredictionGraph/FailurePredictionGraphComponent';

import TitleBar from '../../../titleBar/TitleBar';
import '../../../reports/lineChartReport/LineChartReport.css';
import {
  getInferenceResult, getModel, allAgorithms, createLabels, setSession,
  // retrieveModels,
} from '../../services/testResultsService';
import Loading from '../../../loading/Loading';

class DetectionResults extends Component {
  constructor(props) {
    super(props);

    this.state = {
      barLabels: {
      },
      dataFromS3: {
      },
      detectionModalShow: false,
      device: '',
      devices: [],
      loading: false,
      modelData: {
      },
      modelInformation: {
      },
      multivariateEnabled: false,
      nonProperties: ['std', 'mean', 'raw', 'result', 'transform', 'x-axis', 'index', '0.4', '0.5', '0.6'],
      properties: [],
      resultDataFromDB: {
      },
      selectedProperty: '',
    };
  }

  componentDidMount() {
    this.setOEM();
    const { location } = this.props;
    const resultDataFromDB = location.state.results;
    const {
      RunDate, OemID, JobName, ModelName, VersionID, DevicesEvaluated
    } = resultDataFromDB;
    const { nonProperties } = this.state;

    const device = DevicesEvaluated[0];

    this.retrieveS3Results(RunDate, OemID, JobName, device);

    getModel(ModelName, VersionID).then((data) => {
      if (data.body.Item) {
        const modelData = data.body.Item;
        const properties = modelData.Properties.filter((property) => ! nonProperties.includes(property));
        this.setState({
          barLabels: modelData.modelLabels,
          modelData,
          properties,
        });
      }
    });
    // retrieveModels().then((requestData) => {
    //   const specificModelData = requestData.body.filter(({ trainModelName }) => trainModelName === ModelName)[0];
    //   this.setState({
    //     specificModelData
    //   });
    // });
    if (! localStorage.DontShowDetection) {
      this.setState({
        detectionModalShow: true,
      });
    }

    this.setState({
      devices: DevicesEvaluated,
      resultDataFromDB,
    });

    // Collect data about all algorithms
    allAgorithms().then((data) => {
      if (data.body.Items) {
        const algorithms = data.body.Items;
        const modelInformation = algorithms.filter(
          algorithm => algorithm.modelTypeName === resultDataFromDB.ModelPlotType
        )[0];
        this.setState({
          modelInformation
        });
      }
    });
  }

  setOEM = () => {
    const { session } = this.props;
    setSession(session);
  }

  showHelp = () => {
    this.setState({
      detectionModalShow: true
    });
  }

  closeModal = () => {
    this.setState({
      detectionModalShow: false,
    });
  }

  handleDeviceChange = (device) => {
    const {
      resultDataFromDB: {
        JobName, OemID, RunDate
      },
    } = this.state;
    this.retrieveS3Results(RunDate, OemID, JobName, device);
  }

  handleInputChange = (e) => {
    const { barLabels } = this.state;
    barLabels[e.target.name] = e.target.value;
    this.setState({
      barLabels,
    });
  }

  submitLabels = () => {
    const { barLabels, resultDataFromDB } = this.state;
    const { ModelName, VersionID } = resultDataFromDB;
    const version = parseInt(VersionID, 10);
    createLabels(ModelName, version, barLabels).then(() => {
      // console.log(reqData);
    });
  }

  changeProperty = (property) => {
    const { properties, nonProperties } = this.state;
    const propertiesCopy = properties.splice(0);
    // console.log(propertiesCopy);
    // console.log(property);
    if (property === '' || nonProperties.includes(property)) return;

    if (! propertiesCopy.includes(property)) propertiesCopy.push(property);

    this.setState({
      multivariateEnabled: false,
      properties: propertiesCopy,
      selectedProperty: property,
    });
  }

  toggleMultivariate = () => {
    const { multivariateEnabled } = this.state;
    this.setState({
      multivariateEnabled: ! multivariateEnabled,
      selectedProperty: '',
    });
  }

  retrieveS3Results(date, oem, job, device) {
    this.setState({
      loading: true
    });
    getInferenceResult(date, oem, job, device).then((results) => {
      const {
        nonProperties, properties: oldProperties, selectedProperty
      } = this.state;
      if (! results.body) return;
      const dataFromS3 = results.body;
      // console.log(results.body);
      // console.log(Object.keys(dataFromS3.results));
      // const multiVariate = Object.keys(dataFromS3.results).length > 1;
      const newProperties = dataFromS3.results ? Object.keys(dataFromS3.results) : oldProperties;
      const validProps = ! nonProperties.includes(newProperties[0]);
      const properties = validProps ? newProperties : oldProperties;
      let currentProperty = selectedProperty;
      if (dataFromS3.results) {
        currentProperty = selectedProperty === '' ? Object.keys(dataFromS3.results)[0] : selectedProperty;
      }
      // console.log(currentProperty);
      this.setState({
        dataFromS3,
        device,
        loading: false,
        properties,
      }, this.changeProperty(currentProperty));
    });
  }

  render() {
    const {
      resultDataFromDB, device, dataFromS3, devices, detectionModalShow,
      properties, selectedProperty, modelInformation, modelData, multivariateEnabled, loading
    } = this.state;
    const { modelTypeName } = modelInformation;
    const resultDataFromS3 = dataFromS3.results;
    let splashScreen;
    let splashModal;
    if (detectionModalShow) {
      splashScreen = (
        <DetectionSplash closeModal={this.closeModal} />
      );
      splashModal = (
        <Modal close={this.closeModal}
          title="New to Results?"
          style={{
            width: '95%',
          }}
        >
          {splashScreen}
        </Modal>
      );
    }
    // console.log({dataFromS3});
    // console.log(resultDataFromDB.Normalization);
    const normalizationMethods = {
      diff: 'Diff',
      minmax: 'Min Max',
      pctdiff: '%',
    };
    const normalization = resultDataFromDB.Normalization;
    // console.log({multivariateEnabled});
    // console.log({properties});
    const displayGraph = () => {
      if (typeof dataFromS3.DSN !== 'undefined') {
        if (multivariateEnabled) {
          if (resultDataFromDB.ModelPlotType === 'Moving Average') {
            const data = {
            };
            Object.keys(resultDataFromS3).forEach((property) => {
              data[property] = resultDataFromS3[property]['x-axis'].map((xValue, i) => ({
                padding: resultDataFromS3[property].std[i],
                raw: resultDataFromS3[property].raw[i],
                std: resultDataFromS3[property].result[i],
                x: new Date(resultDataFromS3[property]['x-axis'][i]),
                y1: resultDataFromS3[property].transform[i],
                y2: resultDataFromS3[property].mean[i],
              }));
            });
            return (
              <MovingAverageGraphMultivariate data={data} />
            );
          }
          if (resultDataFromDB.ModelPlotType === 'Random Cut Forest' || resultDataFromDB.ModelPlotType === 'XGBoost') {
            const data = {
            };
            Object.keys(resultDataFromS3).forEach((property) => {
              data[property] = resultDataFromS3[property]['x-axis'].map((xValue, i) => ({
                raw: resultDataFromS3[property].raw[i],
                'x-axis': new Date(resultDataFromS3[property]['x-axis'][i]),
              }));
            });
            return (
              <RCFGraphsMultivariate data={data}
                yAxisLabel={resultDataFromDB.ModelPlotType === 'XGBoost' ? 'Time to Failure (min)' : undefined}
              />
            );
          }
          if (resultDataFromDB.ModelPlotType === 'KMeans Clustering') {
            const data = {
            };
            Object.keys(resultDataFromS3).forEach((property) => {
              data[property] = resultDataFromS3[property]['x-axis'].map((xValue, i) => ({
                raw: resultDataFromS3[property].raw[i],
                result: resultDataFromS3[property].result[i],
                'x-axis': new Date(resultDataFromS3[property]['x-axis'][i]),
              }));
            });
            return (
              <KMeansGraphsMultivariate data={data} />
            );
          }
        }
        if (selectedProperty !== '' && resultDataFromS3[selectedProperty]) {
          // Multivariate
          if (resultDataFromDB.ModelPlotType === 'Moving Average') {
            return (
              <MovingAverageGraph propertyText={selectedProperty}
                normalization={normalizationMethods[normalization] || ''}
                data={resultDataFromS3[selectedProperty]}
                key={selectedProperty}
              />
            );
          }
          if (resultDataFromDB.ModelPlotType === 'Random Cut Forest' || resultDataFromDB.ModelPlotType === 'XGBoost') {
            const data = resultDataFromS3[selectedProperty].result.map((propertyData, i) => ({
              raw: resultDataFromS3[selectedProperty].raw[i],
              result: resultDataFromS3[selectedProperty].result[i],
              transform: resultDataFromS3[selectedProperty].transform[i],
              'x-axis': new Date(resultDataFromS3[selectedProperty]['x-axis'][i]),
            }));
            let yAxisLabel;
            if (resultDataFromDB.ModelPlotType === 'XGBoost') yAxisLabel = 'Time to Failure (min)';
            return (
              <RCFGraphs propertyText={`${selectedProperty}`}
                normalization={normalizationMethods[normalization] || ''}
                yAxisLabel={yAxisLabel}
                data={data}
                key={selectedProperty}
              />
            );
          }
          if (resultDataFromDB.ModelPlotType === 'KMeans Clustering') {
            const groups = [];
            const data = resultDataFromS3[selectedProperty]['x-axis'].map((propertyData, i) => {
              if (! groups.includes(resultDataFromS3[selectedProperty].result[i])) {
                groups.push(resultDataFromS3[selectedProperty].result[i]);
              }
              return {
                raw: resultDataFromS3[selectedProperty].raw[i],
                result: resultDataFromS3[selectedProperty].result[i],
                resultLabel: (modelData && modelData.modelLabels[resultDataFromS3[selectedProperty].result[i]])
                || resultDataFromS3[selectedProperty].result[i],
                transform: resultDataFromS3[selectedProperty].transform[i],
                'x-axis': new Date(resultDataFromS3[selectedProperty]['x-axis'][i]),
              };
            });
            const hyperParams = JSON.parse(modelData.Hyperparameters)[0];
            const showLabels = () => {
              const result = [];
              for (let i = 0.0; i < hyperParams.k; i += 1) {
                const group = i.toFixed(1);
                result.push(
                  <div key={group}
                    className="label-fields"
                  >
                    <label htmlFor={group}>{`Group ${group}`}</label>
                    <input type="text"
                      value={modelData.modelLabels[group] || ''}
                      name={group}
                      onChange={this.handleInputChange}
                    />
                  </div>
                );
              }
              result.push(
                <button className="submit-labels"
                  onClick={this.submitLabels}
                  type="button"
                >
                  {'Submit Labels'}
                </button>
              );
              return result;
            };

            return (
              <div>
                {showLabels()}
                {<KMeansGraphs propertyText={`${selectedProperty}`}
                  data={data}
                  key={selectedProperty}
                />}
              </div>
            );
          }
        }
        // Non-multivariate
        if (resultDataFromDB.ModelPlotType === 'DeepAR') {
          const startTime = resultDataFromDB.RangeStart;
          const inferenceEndTime = resultDataFromDB.RangeEnd;
          const formatStart = moment(startTime, 'YYYYMMDD[T]HH:mm:ss.SSS[Z]');
          const formatEnd = moment(inferenceEndTime, 'YYYYMMDD[T]HH:mm:ss.SSS[Z]');
          const maxTime = moment(resultDataFromS3.index[resultDataFromS3.index.length - 1]);

          const historical = formatEnd.unix() - formatStart.unix();
          const total = maxTime.unix() - formatStart.unix();
          const percentage = historical / total;

          const roundedPercentage = percentage.toFixed(2);
          const dataGraph = resultDataFromS3.index.map((xValue, index) => ({
            lowerlayer: resultDataFromS3['0.4'][index],
            upperlayer: resultDataFromS3['0.6'][index],
            x: new Date(xValue),
            y: resultDataFromS3['0.5'][index],
          }));
          return (
            <DeepARGraph data={dataGraph}
              propertyText={(modelData.Properties && Array.isArray(modelData.Properties))
                && `${modelData.Properties[0] || ''} Value`}
              predictedPercentage={roundedPercentage}
            />
          );
        }
        if (resultDataFromDB.ModelPlotType === 'Cumulative Distribution Function') {
          const failureData = dataFromS3['x-axis'].map((dataXPoint, index) => ({
            x: new Date(dataXPoint),
            y: parseInt(dataFromS3.anomaly_score[index], 10)
          }));
          if (failureData[0].y === -1) {
            return <span>{t('tensorAnalytics.detectionResultsPage.invalidGraphData')}</span>;
          }
          return (
            <FailurePredictionGraphComponent fromPlotService={false}
              propsData={failureData}
            />
          );
        }
      }
      if (loading) {
        return (
          <Loading size={50} />
        );
      }
      return (
        <span>
          {t('tensorAnalytics.detectionResultsPage.invalidGraphData')}
        </span>
      );
    };

    const multivariate = () => {
      const multivariatePlotTypes = ['Moving Average', 'Random Cut Forest', 'XGBoost', 'KMeans Clustering'];
      if (multivariatePlotTypes.includes(resultDataFromDB.ModelPlotType) && properties.length > 1) {
        return (
          <div className={`property-tab ${multivariateEnabled ? 'selected' : 'nonselected'}`}
            onKeyPress={() => this.toggleMultivariate()}
            onClick={() => this.toggleMultivariate()}
            role="button"
            tabIndex="0"
          >
            {'Multivariate'}
          </div>
        );
      }
      return null;
    };

    const modelTypeNameToText = {
      'Cumulative Distribution Function': 'CDF',
      'KMeans Clustering': 'KMeans Clusters',
      'Random Cut Forest': 'RCF',
    };

    const forecastProperties = (Array.isArray(properties) && properties.length > 0);
    const forecastProp = modelData && Array.isArray(modelData.Properties) ? modelData.Properties[0] : '';

    const formattedDate = moment(resultDataFromDB.RunDate, 'YYYYMMDD[T]HH:mm:ss.SSS[Z]').format('MM/DD/YY');
    const formattedTime = moment(resultDataFromDB.RunDate, 'YYYYMMDD[T]HH:mm:ss.SSS[Z]').format('LT');
    return (
      <div className="detection-results-page">
        <div className="">
          <TitleBar title={t('tensorAnalytics.detectionResultsPage.title')}>
            <Help onClick={this.showHelp}
              size={36}
              style={{
                fill: '#669044',
                padding: '5px 7px',
              }}
            />
          </TitleBar>
          <Navbar />
          <div className="page-content">
            <div className="device-info">
              <div className="device-table-container">
                <div className="results-information">
                  <strong>
                    <label htmlFor="schedule-info">
                      {t('tensorAnalytics.detectionResultsPage.scheduleInformation')}
                    </label>
                  </strong>
                  <div className="schedule-info">
                    <div className="model">
                      <strong>
                        {t('tensorAnalytics.detectionResultsPage.name')}
                        {': '}
                      </strong>
                      {resultDataFromDB.JobName}
                    </div>
                    <div className="model">
                      <strong>
                        {t('tensorAnalytics.detectionResultsPage.modelInfo')}
                        {': '}
                      </strong>
                      {modelInformation ? `${modelTypeNameToText[modelTypeName] || modelTypeName}` : ''}
                    </div>
                    <div className="model">
                      <strong>
                        {t('tensorAnalytics.tableHeaders.ModelType')}
                        {': '}
                      </strong>
                      {modelInformation ? `${modelInformation.Type}` : ''}
                    </div>
                    <div>
                      <strong>
                        {t('tensorAnalytics.detectionResultsPage.runDate')}
                        {': '}
                      </strong>
                      {formattedDate}
                    </div>
                    <div>
                      <strong>
                        {t('tensorAnalytics.detectionResultsPage.runTime')}
                        {': '}
                      </strong>
                      {formattedTime}
                    </div>
                    <div>
                      <strong>
                        {t('tensorAnalytics.detectionResultsPage.normalization')}
                        {': '}
                      </strong>
                      {resultDataFromDB.Normalization}
                    </div>
                    <div className="properties-list">
                      <strong>
                        {t('tensorAnalytics.detectionResultsPage.properties')}
                        {': '}
                      </strong>
                      {/* resultDataFromDB.ModelPlotType === 'DeepAR' ? modelData.Properties[0] : */}
                      <ul>
                        {forecastProperties ? properties.map(property => <li key={property}>{property}</li>)
                          : (<li key={forecastProp}>{forecastProp}</li>)}
                      </ul>
                    </div>
                  </div>
                </div>
                <label htmlFor="device-table">
                  {t('tensorAnalytics.detectionResultsPage.selectDevice')}
                </label>
                <ReactTable data={devices}
                  name="device-table"
                  columns={[
                    {
                      accessor: '',
                      Cell: row => (
                        <div onClick={() => { this.handleDeviceChange(row.original); }}
                          onKeyPress={() => { this.handleDeviceChange(row.original); }}
                          role="button"
                          tabIndex={0}
                        >
                          {row.value}
                        </div>
                      ),
                      Header: t('tensorAnalytics.tableHeaders.DSN'),
                    },
                  ]}
                  filterable
                  showPagination
                  showPageSizeOptions={false}
                  showPageJump={false}
                  // getPaginationProps={(state) => ({
                  //   style: {
                  //     // backgroundColor: 'green',
                  //   }
                  // })}
                  getTrProps={(state, rowInfo) => ({
                    className: (rowInfo && rowInfo.original === device) ? 'selectable' : '',
                    onClick: rowInfo ? () => {
                      this.setState({
                        device: rowInfo.original,
                      });
                    } : null,
                    style: {
                      backgroundColor: (rowInfo && rowInfo.original === device) ? '#D7EFF5' : 'initial',
                    },
                  })}
                />
              </div>
            </div>
            <div>
              {properties.length > 0 && (
                <div className="top">
                  {properties.map((property) => (
                    <div className={`property-tab ${property === selectedProperty ? 'selected' : 'nonselected'}`}
                      key={property}
                      onKeyPress={() => this.changeProperty(property)}
                      onClick={() => this.changeProperty(property)}
                      role="button"
                      tabIndex="0"
                    >
                      {property}
                    </div>
                  ))}
                  {multivariate()}
                </div>
              )}
              <div>
                <em className="schedule-info algorithm-info">
                  <strong>Algorithm Information: </strong>
                  {modelInformation ? modelInformation.Information : ''}
                </em>
              </div>
              <br />
              <div className="graphContent">
                {displayGraph()}
              </div>
            </div>
          </div>
        </div>
        <div className={detectionModalShow ? 'show' : 'hide'}>
          {splashModal}
        </div>
      </div>
    );
  }
}

export default DetectionResults;
